export default "__VITE_ASSET__bc740cf3__"